/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import * as _ from 'lodash';

import {ApiConfig} from '../api/api';
import {AdnHttpService} from './adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from './create-adn-http-resource';
import {AuthHttpInterceptorService} from '../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../app/common/directives/error/api-error-handler.service';



@Injectable({
  providedIn: 'root'
})
export class AdnAdDensityService {
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  fetchAll(): Promise<any> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['adnaddensity', 'fetchall']),
      params: _.assign({}, {format: 'json', concise: true})
    });
  }

  deleteEntry(add: any): Promise<any> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['adnaddensity', 'deleteentry']),
      params: _.assign({}, {format: 'json', concise: true, adDensityId: add.idOfAdDensity})
    });
  }

  takeAdDensity(url: string, bypassSave?: boolean): Promise<any> {
    return this.send({
      method: 'GET',
      url: ApiConfig.obtain().getVersionedUri(['adnaddensity', 'takeaddensity']),
      params: _.assign({}, {format: 'json', concise: true, url: url, bypassSave: bypassSave})
    });
  }
}
